export default "__VITE_ASSET__ybcWtcq3__"